// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-chat {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #1a1a2e;
  border-radius: 12px;
  overflow: hidden;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #16213e;
  border-bottom: 1px solid #0f3460;
}

.chat-header h3 {
  margin: 0;
  color: #e94560;
  font-size: 18px;
  font-weight: 600;
}

.message-count {
  color: #a0a0a0;
  font-size: 14px;
}

.chat-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #a0a0a0;
  font-size: 14px;
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.no-messages {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #a0a0a0;
  text-align: center;
  padding: 40px 20px;
}

.no-messages p {
  margin: 8px 0;
  font-size: 14px;
}

.message-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.date-separator {
  display: flex;
  justify-content: center;
  margin: 16px 0;
}

.date-separator span {
  background: #16213e;
  color: #a0a0a0;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
}

.message {
  display: flex;
  gap: 8px;
  max-width: 80%;
}

.message.own {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.message.other {
  align-self: flex-start;
}

.message-avatar {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
}

.message-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: #e94560;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
}

.message-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.message-sender {
  font-size: 12px;
  color: #e94560;
  font-weight: 500;
  margin-left: 4px;
}

.message-bubble {
  background: #16213e;
  padding: 10px 14px;
  border-radius: 16px;
  position: relative;
}

.message.own .message-bubble {
  background: #e94560;
  color: white;
}

.message-bubble p {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  word-wrap: break-word;
}

.message-time {
  font-size: 10px;
  color: #a0a0a0;
  margin-top: 4px;
  display: block;
  text-align: right;
}

.message.own .message-time {
  color: rgba(255, 255, 255, 0.7);
}

.chat-input-form {
  display: flex;
  gap: 8px;
  padding: 16px;
  background: #16213e;
  border-top: 1px solid #0f3460;
}

.chat-input-form input {
  flex: 1 1;
  padding: 12px 16px;
  border: none;
  border-radius: 24px;
  background: #0f3460;
  color: white;
  font-size: 14px;
  outline: none;
}

.chat-input-form input::placeholder {
  color: #a0a0a0;
}

.chat-input-form input:focus {
  background: #1a1a2e;
  box-shadow: 0 0 0 2px #e94560;
}

.chat-input-form button {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: #e94560;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s;
}

.chat-input-form button:hover:not(:disabled) {
  background: #d63851;
}

.chat-input-form button:disabled {
  background: #a0a0a0;
  cursor: not-allowed;
}

/* Scrollbar styling */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #1a1a2e;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #0f3460;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #e94560;
}
`, "",{"version":3,"sources":["webpack://./src/components/RoomChat.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".room-chat {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  background: #1a1a2e;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.chat-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px 20px;\r\n  background: #16213e;\r\n  border-bottom: 1px solid #0f3460;\r\n}\r\n\r\n.chat-header h3 {\r\n  margin: 0;\r\n  color: #e94560;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.message-count {\r\n  color: #a0a0a0;\r\n  font-size: 14px;\r\n}\r\n\r\n.chat-loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  color: #a0a0a0;\r\n  font-size: 14px;\r\n}\r\n\r\n.chat-messages {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.no-messages {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  color: #a0a0a0;\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n}\r\n\r\n.no-messages p {\r\n  margin: 8px 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.message-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.date-separator {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 16px 0;\r\n}\r\n\r\n.date-separator span {\r\n  background: #16213e;\r\n  color: #a0a0a0;\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n.message {\r\n  display: flex;\r\n  gap: 8px;\r\n  max-width: 80%;\r\n}\r\n\r\n.message.own {\r\n  align-self: flex-end;\r\n  flex-direction: row-reverse;\r\n}\r\n\r\n.message.other {\r\n  align-self: flex-start;\r\n}\r\n\r\n.message-avatar {\r\n  flex-shrink: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  overflow: hidden;\r\n}\r\n\r\n.message-avatar img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.avatar-placeholder {\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #e94560;\r\n  color: white;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n}\r\n\r\n.message-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.message-sender {\r\n  font-size: 12px;\r\n  color: #e94560;\r\n  font-weight: 500;\r\n  margin-left: 4px;\r\n}\r\n\r\n.message-bubble {\r\n  background: #16213e;\r\n  padding: 10px 14px;\r\n  border-radius: 16px;\r\n  position: relative;\r\n}\r\n\r\n.message.own .message-bubble {\r\n  background: #e94560;\r\n  color: white;\r\n}\r\n\r\n.message-bubble p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.message-time {\r\n  font-size: 10px;\r\n  color: #a0a0a0;\r\n  margin-top: 4px;\r\n  display: block;\r\n  text-align: right;\r\n}\r\n\r\n.message.own .message-time {\r\n  color: rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n.chat-input-form {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 16px;\r\n  background: #16213e;\r\n  border-top: 1px solid #0f3460;\r\n}\r\n\r\n.chat-input-form input {\r\n  flex: 1;\r\n  padding: 12px 16px;\r\n  border: none;\r\n  border-radius: 24px;\r\n  background: #0f3460;\r\n  color: white;\r\n  font-size: 14px;\r\n  outline: none;\r\n}\r\n\r\n.chat-input-form input::placeholder {\r\n  color: #a0a0a0;\r\n}\r\n\r\n.chat-input-form input:focus {\r\n  background: #1a1a2e;\r\n  box-shadow: 0 0 0 2px #e94560;\r\n}\r\n\r\n.chat-input-form button {\r\n  width: 44px;\r\n  height: 44px;\r\n  border: none;\r\n  border-radius: 50%;\r\n  background: #e94560;\r\n  color: white;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.chat-input-form button:hover:not(:disabled) {\r\n  background: #d63851;\r\n}\r\n\r\n.chat-input-form button:disabled {\r\n  background: #a0a0a0;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.chat-messages::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.chat-messages::-webkit-scrollbar-track {\r\n  background: #1a1a2e;\r\n}\r\n\r\n.chat-messages::-webkit-scrollbar-thumb {\r\n  background: #0f3460;\r\n  border-radius: 3px;\r\n}\r\n\r\n.chat-messages::-webkit-scrollbar-thumb:hover {\r\n  background: #e94560;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
